import Sortable from 'sortablejs';
import selectors from './selectors';
import CartItems from './cartItems';

const { table } = selectors;

const connectSortable = (tbody) => {

    Sortable.create(
        tbody,
        {
            handle: table.reorder,
            animation: 0,
            onEnd: () => {
                $(table.check).each((index, el) => {
                    const cartItem = CartItems.findWhere({
                        resourceId: el.value,
                        language: el.dataset.language,
                    });
                    cartItem.setOrder(index);
                });
            },
        },
    );
};

export default connectSortable;
